import { type ApiWorkflowDefinition } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const workflowDefinitionColumns: Column<ApiWorkflowDefinition>[] = [
    { name: 'definition_key', label: 'Key' },
    { name: 'label', label: 'Bezeichnung' },
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'remarks', label: 'Beschreibung' },
    { name: 'created_at', label: 'Angelegt', type: 'datetime' },
    { name: 'modified_at', label: 'Geändert', type: 'datetime' },
];
